import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './ImageSlider.css'; // for custom styling

const images = [
    "images/02.jpg",
    "images/03.jpg",
    "images/04.jpg",
];

const Slider = () => {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % images.length);
        }, 3000);
        return () => clearInterval(timer);
    }, []);

    return (
       <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 3000, // 3 seconds per slide
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      <SwiperSlide>
        <div className="slide">
          <img src="/images/slider2.jpg" alt="Slide 1" />
          <div className="slide-text">
            <h2>Transforming Ideas Into Digital Reality</h2>
            <p>Custom-built applications for your business success.</p>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="slide">
          <img src="images/slider1.jpg" alt="Slide 2" />
          <div className="slide-text">
            <h2>Your Trusted Technology Partner</h2>
            <p>Delivering excellence, one solution at a time.</p>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="slide">
          <img src="images/slider3.jpg" alt="Slide 3" />
          <div className="slide-text">
            <h2>Where Innovation Meets Execution</h2>
            <p>We design, develop, and deliver smart digital experiences</p>
          </div>
        </div>
      </SwiperSlide>
         <SwiperSlide>
        <div className="slide">
          <img src="images/slider4.jpg" alt="Slide 3" />
          <div className="slide-text">
            <h2>We Build the Future of Software</h2>
            <p>Transforming your vision into scalable technology.</p>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
    );
};

export default Slider;